export interface ContactRequest {
    to: string[];
    cc: string[];
    bcc: string[];
    senderEmail: string;
    senderName: string;
    subject: string;
    body: string;
    isHtml: boolean;
};

export const sendEmail = async (request: ContactRequest) => {
    const response = await fetch('https://lpemail.logicplayers.com/api/email/send', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Api-Key': 'l6KmTO9FCwcJotfVqHxTktZRm609KJA8eD3cYuL_3gI'
        },
        body: JSON.stringify(request),
    });
    return response.json();
};
